import { CompanyDetailOutputData } from './company-detail-output-data.model';


export class CompanyDetailSelectByIdOutput implements ICompanyDetailSelectByIdOutput {
    status!: number;
    message!: string;
    data!: CompanyDetailOutputData;

    constructor(data?: ICompanyDetailSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? CompanyDetailOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CompanyDetailSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDetailSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ICompanyDetailSelectByIdOutput {
    status: number;
    message: string;
    data: CompanyDetailOutputData;
}

